import React, { useState } from 'react';
import Marquee from 'react-fast-marquee';
import { FaPlus } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import IframePlayer from '../../../../../../components/IframePlayer';
import IframePlayerMobile from '../../../../../../components/IframePlayerMobile';

import { ContainerLineUI } from '../../../../../../components/UIComponents/ContainerLine/styles';
import ParagraphDangerous from '../../../../../../components/UIComponents/ParagraphDangerous';
import { TitleHighlightUI } from '../../../../../../components/UIComponents/TitleHighlight/styles';

import { urlWebsite } from '../../../../../../config';
import { useModal } from '../../../../../../hooks/Modal';

interface IList {

    title?: string;
    text?: string;
    video: string;
    image?: string;

}

interface IProps {
    list: Array<IList>,
    title?: string;
    background?: string;
    color: string;
    inactiveColor: string;
}
const RenderIcons: React.FC<IProps> = ({ title, list }) => {

    return <>
        <div className='full-width column' style={{ padding: '50px 15px' }}>

        </div>

    </>

}
const RenderVideoList: React.FC<IProps> = ({ list, title, background, color, inactiveColor }) => {

    const [activeIndex, setActiveIndex] = useState(0);
    const { addModal } = useModal();



    return <ContainerLineUI className='full-width row-to-column gap' style={{ gap: '5px', width: '100%' }}>
        {list?.map(items => {
            return <div style={{ maxWidth: '250px', width: '100%' }}>
                <IframePlayerMobile id={items?.video} />

            </div>
        })}





    </ContainerLineUI>


}

export default RenderVideoList;